import styles from './AboutPage.module.css';
import groupPhoto from '../../assets/groupPhoto.png';
import FlippableCard from '../../components/FlippableCard/FlippableCard';
import { teamMembers, mentors } from './teamInfo';

const AboutPage = (): JSX.Element => {
  return (
    <div className={styles.container}>
      <div className={styles.title}>Meet The Team</div>
      <div className={styles.teamPhoto}>
        <img src={groupPhoto} alt="Team Photo" className={styles.team} />
      </div>
      <div className={styles.cardContainer}>
        <div className={styles.cards}>
          {teamMembers.map((teamMember) => {
            return (
              <FlippableCard
                name={teamMember.name}
                role="Member"
                description={teamMember.description}
                imageSource={teamMember.imageSource}
              />
            );
          })}
        </div>
        <div className={styles.cards}></div>
        <div className={`${styles.cards} ${styles.lastRow}`}>
          {mentors.map((mentor) => {
            return (
              <FlippableCard
                name={mentor.name}
                role={mentor.role}
                description={mentor.description}
                imageSource={mentor.imageSource}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default AboutPage;
